module.exports = __webpack_public_path__ + "img/arrow-left.f6817540.svg";